import moment from "moment"
import { styled } from "styled-components"

import { AiMessage } from "../model"

import { MessageAttachments } from "./MessageAttachments"

interface MyMessageProps {
  message: AiMessage
}

export const MyMessage = ({ message }: MyMessageProps) => {
  return (
    <SMyMessageContainer key={message.id}>
      <SMessagesWrapper>
        <SMyMessage
          dangerouslySetInnerHTML={{ __html: (message.content || '').replace(/\n/g, '<br />') }}
        />

        {message.attachments.length > 0 && (
          <SAttachmentsWrapper>
            <MessageAttachments 
              attachments={message.attachments} 
              type="ai-assistant-user"
            />
          </SAttachmentsWrapper>

        )}
      </SMessagesWrapper>

      <STimestamp>
        {moment(message.timestamp).fromNow()}
      </STimestamp>
    </SMyMessageContainer>
  )
}

const SMyMessageContainer = styled.div`
  padding-left: 56px;
`

const SMessagesWrapper = styled.div`
  padding: 16px;
  border-radius: 16px;
  border-bottom-right-radius: 0;
  background-color: var(--ant-color-primary-bg-hover);
`

const SMyMessage = styled.div`
  color: #000000E0;
  font-size: 14px;
  line-height: 22px;
  font-weight: 400;
  white-space: pre-wrap;
`

const STimestamp = styled.div`
  margin-top: 10px;
  color: #00000073;
  font-size: 12px;
  line-height: 22px;
  font-weight: 400;
`

const SAttachmentsWrapper = styled.div`
  margin-top: 16px;
`